import { api, getApiUrl } from 'utils/api';

const BASE_URL = getApiUrl('');

export const noticeAdminApi = {
  deleteNotice: (noticeId: number): Promise<void> =>
    api(`${BASE_URL}/notices/${noticeId}`, { method: 'DELETE' }),
};
